let lastScroll = 0;

// Main navigation (desktop): keep the chosen categories on one line by
// hiding, from the end, any that don't fit. Every category is still
// reachable from the "Sve kategorije" drawer.
(function () {
  const list = document.querySelector('#site-header-nav .navmenu-depth-1');
  if (!list) return;

  const fit = () => {
    const items = Array.from(list.children);
    items.forEach((item) => item.classList.remove('vm-nav-overflow'));
    for (let i = items.length - 1; i > 0 && list.scrollWidth > list.clientWidth + 1; i--) {
      items[i].classList.add('vm-nav-overflow');
    }
  };

  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(list);
  window.addEventListener('resize', fit);
  if (document.fonts) document.fonts.ready.then(fit);
  fit();
})();

// "Sve kategorije" panel (snippets/vm-desktop-menu-drawer.liquid).
// Clicking a category opens its subcategories; the product column is loaded
// from sections/vm-menu-products.liquid and follows the hovered subcategory.
// Opened by the desktop button and, on mobile, by the header's menu toggle
// (instead of Empire's drawer), where it works as two sliding screens.
(function () {
  const drawer = document.querySelector('[data-vm-menu-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;

  const root = document.documentElement;
  const panel = drawer.querySelector('[data-vm-menu-panel]');
  const subColumn = drawer.querySelector('.vm-menu-drawer__col--sub');
  const detail = drawer.querySelector('[data-vm-menu-detail]');
  const productsColumn = drawer.querySelector('[data-vm-menu-products]');
  const detailTitle = drawer.querySelector('[data-vm-menu-detail-title]');
  const backButton = drawer.querySelector('[data-vm-menu-back]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const productsHidden = window.matchMedia('(min-width: 1024px) and (max-width: 1279px)');
  const canHover = window.matchMedia('(hover: hover)');
  const cache = new Map();
  let closeTimer = null;
  let hoverTimer = null;
  let currentCategory = null;
  let requestedPath = null;
  let opener = null;

  // Only plain collection URLs (optionally locale-prefixed) have products to preview.
  const collectionPath = (url) => {
    try {
      const { origin, pathname } = new URL(url, window.location.origin);
      const isCollection = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(pathname);
      return origin === window.location.origin && isCollection ? pathname : null;
    } catch (error) {
      return null;
    }
  };

  const loadProducts = (path) => {
    if (!cache.has(path)) {
      const request = fetch(`${path}?section_id=vm-menu-products`)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-vm-menu-products-content]');
          return content ? content.outerHTML : '';
        })
        .catch(() => {
          cache.delete(path);
          return '';
        });
      cache.set(path, request);
    }
    return cache.get(path);
  };

  // clearIfEmpty: a category click replaces the preview even when it has no
  // products; a hover keeps the previous preview instead.
  const showProducts = (url, clearIfEmpty) => {
    if (!productsColumn || productsHidden.matches) return;
    const path = collectionPath(url);
    if (path === requestedPath) return;
    if (!path) {
      if (clearIfEmpty) {
        requestedPath = null;
        productsColumn.innerHTML = '';
        panel.classList.remove('has-products');
      }
      return;
    }

    requestedPath = path;
    productsColumn.classList.add('is-loading');
    loadProducts(path).then((html) => {
      if (requestedPath !== path) return;
      productsColumn.classList.remove('is-loading');
      if (html) {
        productsColumn.innerHTML = html;
        productsColumn.scrollTop = 0;
        panel.classList.add('has-products');
      } else if (clearIfEmpty) {
        productsColumn.innerHTML = '';
        panel.classList.remove('has-products');
      }
    });
  };

  const selectCategory = (button) => {
    const toggleOff = button === currentCategory;
    drawer.querySelectorAll('[data-vm-menu-cat]').forEach((cat) => cat.setAttribute('aria-expanded', 'false'));
    drawer.querySelectorAll('[data-vm-menu-sub]').forEach((sub) => { sub.hidden = true; });
    drawer.querySelectorAll('.is-previewing').forEach((link) => link.classList.remove('is-previewing'));

    if (!button || toggleOff) {
      currentCategory = null;
      requestedPath = null;
      panel.classList.remove('has-sub', 'has-products');
      return;
    }

    currentCategory = button;
    button.setAttribute('aria-expanded', 'true');
    drawer.querySelector(`[data-vm-menu-sub="${button.dataset.vmMenuCat}"]`).hidden = false;
    detailTitle.textContent = button.querySelector('.vm-menu-drawer__cat-title').textContent;
    subColumn.scrollTop = 0;
    detail.scrollTop = 0;
    panel.classList.add('has-sub');
    showProducts(button.dataset.vmProductsUrl, true);
  };

  // Mobile back button: slide back to the categories, keeping the detail
  // screen's content in place while it slides out.
  const goBack = () => {
    const category = currentCategory;
    panel.classList.remove('has-sub');
    if (category) category.setAttribute('aria-expanded', 'false');
    currentCategory = null;
    requestedPath = null;
    if (category) category.focus({ preventScroll: true });
  };

  const open = (trigger) => {
    clearTimeout(closeTimer);
    opener = trigger;
    if (!drawer.open) drawer.showModal();
    root.classList.add('vm-menu-drawer-open');
    opener.setAttribute('aria-expanded', 'true');
    if (!currentCategory && !mobile.matches) {
      const current = drawer.querySelector('[data-vm-menu-cat].is-current');
      if (current) selectCategory(current);
    }
    // Two frames so the closed state is painted before transitioning in.
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
  };

  const close = () => {
    if (!drawer.open) return;
    drawer.classList.remove('is-open');
    root.classList.remove('vm-menu-drawer-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    closeTimer = setTimeout(() => {
      drawer.close();
      selectCategory(null);
    }, reducedMotion.matches ? 0 : 380);
  };

  const desktopButton = document.querySelector('[data-vm-menu-open]');
  if (desktopButton) desktopButton.addEventListener('click', () => open(desktopButton));

  // Mobile: take over Empire's menu toggle. Capture phase runs before
  // Empire's own click listener on the button, which then never fires.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle || !mobile.matches) return;
    event.preventDefault();
    event.stopPropagation();
    open(toggle);
  }, true);

  drawer.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer || event.target.closest('[data-vm-menu-close]')) {
      close();
      return;
    }
    if (event.target.closest('[data-vm-menu-back]')) {
      goBack();
      return;
    }
    const category = event.target.closest('[data-vm-menu-cat]');
    if (!category) return;
    selectCategory(category);
    if (mobile.matches && currentCategory) backButton.focus({ preventScroll: true });
  });

  // Hovering (or tabbing to) a subcategory previews its products.
  const preview = (event) => {
    const link = event.target.closest('[data-vm-products-url]');
    if (!link || mobile.matches || (event.type === 'mouseover' && !canHover.matches)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      subColumn.querySelectorAll('.is-previewing').forEach((item) => item.classList.remove('is-previewing'));
      if (collectionPath(link.href)) link.classList.add('is-previewing');
      showProducts(link.href, false);
    }, 150);
  };
  subColumn.addEventListener('mouseover', preview);
  subColumn.addEventListener('focusin', preview);
  subColumn.addEventListener('mouseleave', () => clearTimeout(hoverTimer));

  // Add to cart without leaving the page; falls back to a normal form post.
  if (productsColumn) {
    productsColumn.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-vm-add-to-cart]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      const label = button.textContent;
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      button.disabled = true;

      fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          return fetch(`${cartRoot}cart.js`).then((cart) => cart.json());
        })
        .then((cart) => {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
          button.classList.add('is-added');
          button.textContent = form.dataset.addedLabel || label;
          setTimeout(() => {
            button.classList.remove('is-added');
            button.textContent = label;
            button.disabled = false;
          }, 2000);
        })
        .catch(() => form.submit());
    });
  }
})();


// Sticky header: mark .site-header once it is stuck to the top of the window
// (shadow + slightly tighter header, see custom.css) and publish its height
// as --vm-header-height for other sticky elements (collection sidebar).
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let ticking = false;
  const update = () => {
    ticking = false;
    const stuck = window.scrollY > 0 && header.getBoundingClientRect().top <= 0;
    header.classList.toggle('vm-header-stuck', stuck);
  };

  const publishHeight = () => {
    document.documentElement.style.setProperty('--vm-header-height', `${header.offsetHeight}px`);
  };
  if ('ResizeObserver' in window) new ResizeObserver(publishHeight).observe(header);
  publishHeight();

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });
  update();
})();
